<script>
import Vue from 'vue';
import DibbleTranslation from '../../translation/translation';
import VueRouter from 'vue-router';
import LoginEmailPassword from '@/components/Auth/subs/LoginEmailPassword.vue';
import LoginVerification from '@/components/Auth/subs/LoginVerification.vue';
import LoginOTP from '@/components/Auth/subs/LoginOTP.vue';
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import is from 'vue2-datepicker/locale/es/is';
import Authorizations from "@/utils/authorizations";

Vue.use(require('vue-cookies'));
Vue.use(VueRouter);

export default {
    computed: {
        is() {
            return is;
        },
    },
    components: { LoginOTP, LoginVerification, LoginEmailPassword },
    data() {
        return {
            translate: DibbleTranslation,
            errors: [],
            isMainLogin: true,
            isLoginVerification: false,
            verificationData: {},
            verificationType: '',
            isOtpSent: false,
        };
    },
    methods: {
        processToDashboard(permission_level) {
            window.location.href=Authorizations.getRouteAfterLogin(permission_level);
        },
        performVerificationProgress(responseData) {
            this.verificationData = responseData;
            this.isMainLogin = false;
            this.isLoginVerification = true;
            this.isOtpSent = false;
        },
        sendVerificationCode(type) {
            this.verificationType = type;
            DibbleJs.showLoader();

            const data = {
                '#request': this.verificationData.is_owner ? DibbleApi.api.sendOtpCode : DibbleApi.api.managedUserSendOtpCode,
                second_factor_key: this.verificationData.second_factor_key,
                factor_type: type.toUpperCase(),
            };
            DibbleJs.callApiRequest(data, (responseData) => {
                if (DibbleApi.isResponseSuccess(responseData)) {
                    DibbleJs.toastSuccessMessage(
                        'Verification code sent successfully'
                    );
                    this.isLoginVerification = false;
                    this.isOtpSent = true;
                    this.$refs.otpRef.clearCode();
                    this.$refs.otpRef.startResendCodeInterval();
                } else {
                    DibbleJs.toastErrorMessage(responseData.message);
                }
                DibbleJs.hideLoader();
            });
        },
        resendCode() {
            DibbleJs.showLoader();
            const data = {
                '#request': this.verificationData.is_owner ? DibbleApi.api.resendOtpCode : DibbleApi.api.managedUserResendOtpCode,
                second_factor_key: this.verificationData.second_factor_key,
                factor_type: this.verificationType.toUpperCase(),
            };
            DibbleJs.callApiRequest(data, (responseData) => {
                if (DibbleApi.isResponseSuccess(responseData)) {
                    DibbleJs.toastSuccessMessage(
                        'Verification code sent successfully'
                    );
                    this.$refs.otpRef.clearCode();
                    this.$refs.otpRef.startResendCodeInterval();
                } else {
                    DibbleJs.toastErrorMessage(responseData.message);
                }
                DibbleJs.hideLoader();
            });
        },
        performVerificationOtp(code) {
            DibbleJs.showLoader();
            const data = {
                '#request': this.verificationData.is_owner ? DibbleApi.api.verifyOtpCode : DibbleApi.api.managedUserVerifyOtpCode,
                second_factor_key: this.verificationData.second_factor_key,
                factor_type: this.verificationType.toUpperCase(),
                verification_code: code,
            };
            DibbleJs.callApiRequest(data, (responseData) => {
                if (DibbleApi.isResponseSuccess(responseData)) {
                    this.$cookies.set('_token', responseData.token, '365d');
                    this.$cookies.set(
                        '_user', responseData,
                        '365d'
                    );
                    this.processToDashboard(responseData.permission_level);
                } else {
                    DibbleJs.toastErrorMessage(responseData.message);
                }
                DibbleJs.hideLoader();
            });
        },
        resetLoginData() {
            this.verificationData = {};
            this.verificationType = '';
        },
        goPreviousPage() {
            if (this.isOtpSent) {
                this.isOtpSent = false;
                this.isLoginVerification = true;
                return false;
            }

            if (this.isLoginVerification) {
                this.isLoginVerification = false;
                this.isMainLogin = true;
                this.resetLoginData();
                this.$refs.loginRef.reset();
                return false;
            }
        },
    },
};
</script>
<template src="./template/index.html"></template>
<style>
.login-wrapper {
    background-color: #f8f8f8;
    font-size: 17px;
    color: #717171;
}

.login-left-wrapper {
    background-image: url('~@/assets/images/bg-login.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.logo-wrapper {
    margin-block-end: 150px;
}
.Auth {
    color: #ffffff;
}
.login-form {
    inline-size: 100%;
    inline-size: calc(100% - 24px);
    max-inline-size: 580px;
    margin: 0 auto;
    background: white;
    padding: 40px 40px;
    box-shadow: 0 3px 9px 1px #e5e5e5;
    border-radius: 8px;
}

.description {
    opacity: 0.4;
}

.divider {
    background: #4a4a4a;
    block-size: 20px;
    margin-inline: 10px;
    min-inline-size: 1px;
    margin-top: 3px;
}

.login-logo {
    width: 250px;
}

.login-form .form-box {
    background: #e1e7e9 !important;
}
.toggle-view-password {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    right: 15px;
    z-index: 3;
}

.back-btn {
    position: absolute;
    left: 1px;
    top: -30px;

    &.bottom {
        top: auto;
        bottom: -40px;
    }
}
</style>
